import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BusinessHeroImage } from '../../ng-for-business.models';

@Component({
  selector: 'app-ng-business-hero',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './business-hero.component.html',
  styleUrls: ['./business-hero.component.scss'],
})
export class BusinessHeroComponent {
  @Input({ required: true }) overTitle!: string;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) subtitle!: string;
  @Input({ required: true }) image!: BusinessHeroImage;
}
